import { render, staticRenderFns } from "./service_request_details.vue?vue&type=template&id=49433048&"
import script from "./service_request_details.vue?vue&type=script&lang=js&"
export * from "./service_request_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports